import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withKeys as _withKeys, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b022300e"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("研究成果")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("成果展示")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("期刊论文")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("专利")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("荣誉奖励")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("研究领域")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("新闻资讯")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("资料")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("关于我们")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("实验室")
const _hoisted_12 = /*#__PURE__*/_createTextVNode("个人简介")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("毕业生")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("加入我们")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("合作")
const _hoisted_16 = { style: {"margin-top":"12px","margin-right":"80px","margin-left":"40px","width":"160px"} }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", null, [
  /*#__PURE__*/_createElementVNode("ul", { style: {"margin-left":"-500px"} }, [
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { class: "logo" }, " AiLab ")
        ]),
        /*#__PURE__*/_createElementVNode("li", { style: {"margin-top":"20px"} }, [
          /*#__PURE__*/_createElementVNode("a", null, [
            /*#__PURE__*/_createElementVNode("div", { id: "busuanzi_container_site_pv" }, [
              /*#__PURE__*/_createTextVNode(" 本站总访问量"),
              /*#__PURE__*/_createElementVNode("span", { id: "busuanzi_value_site_pv" }),
              /*#__PURE__*/_createTextVNode("次 ")
            ])
          ]),
          /*#__PURE__*/_createElementVNode("a", null, [
            /*#__PURE__*/_createElementVNode("div", { id: "sitetime" })
          ])
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "版权所有©电力数据智能分析与可视化")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "mailto:sweezin@qq.com" }, "Email:sweezin@qq.com")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "电话:13371896863")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://beian.miit.gov.cn/",
            target: "_blank"
          }, " 沪ICP备2021028694号")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("li", null, [
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", { href: "#" }, "友情链接:")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://www.shiep.edu.cn/",
            target: "_Blank"
          }, "上海电力大学官网")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("a", {
            href: "https://dxxy.shiep.edu.cn/",
            target: "_Blank"
          }, "上海电力大学电子与信息工程学院官网")
        ])
      ])
    ])
  ])
], -1))

import { ref, watch, reactive, onMounted,computed } from "vue";
import { Search } from "@element-plus/icons-vue";
import { useRoute, useRouter } from "vue-router";
import store from '@/store/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();

const router = useRouter();
const activeIndex = ref("/home");
const searchValue = ref("");
router.beforeEach((to, from, next) => {
  document.body.scrollTop = 0;
  // firefox
  document.documentElement.scrollTop = 0;
  next();
});

activeIndex.value = computed(() => store.state.name).value

watch(
  () => route.fullPath,
  (n, o) => {
    activeIndex.value = n;
  }
);
const handleSelect = (key: string, keyPath: string[]) => {
  router.push(key);
};

const search = () => {
  router.push("/search?keywords=" + searchValue.value);
};

return (_ctx: any,_cache: any) => {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_header = _resolveComponent("el-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_el_main = _resolveComponent("el-main")!
  const _component_el_footer = _resolveComponent("el-footer")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_el_header, { class: "suep-head" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_menu, {
            style: {"height":"56px"},
            "default-active": activeIndex.value,
            ellipsis: false,
            class: "el-menu-demo",
            mode: "horizontal",
            "background-color": "#fff",
            "text-color": "#54616C",
            onSelect: handleSelect
          }, {
            default: _withCtx(() => [
              _createElementVNode("a", null, [
                _createVNode(_component_el_image, {
                  src: "/logo.png",
                  alt: "logo'",
                  class: "suep-logo"
                })
              ]),
              _createVNode(_component_el_menu_item, { index: "/home" }, {
                default: _withCtx(() => [
                  _hoisted_1
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "/researchResults" }, {
                title: _withCtx(() => [
                  _hoisted_2
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "/showAchievement" }, {
                    default: _withCtx(() => [
                      _hoisted_3
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/papers" }, {
                    default: _withCtx(() => [
                      _hoisted_4
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/patents" }, {
                    default: _withCtx(() => [
                      _hoisted_5
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/awards" }, {
                    default: _withCtx(() => [
                      _hoisted_6
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "/researchAreas" }, {
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "/news",
                class: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "/data",
                class: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              }),
              _createVNode(_component_el_sub_menu, { index: "/about" }, {
                title: _withCtx(() => [
                  _hoisted_10
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_el_menu_item, { index: "/laboratory" }, {
                    default: _withCtx(() => [
                      _hoisted_11
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/personalProfile" }, {
                    default: _withCtx(() => [
                      _hoisted_12
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_menu_item, { index: "/graduates" }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "/joinUs",
                class: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_el_menu_item, {
                index: "/cooperate",
                class: ""
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_el_input, {
                  onKeyup: _withKeys(search, ["enter"]),
                  modelValue: searchValue.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchValue).value = $event)),
                  class: "w-50 m-2",
                  placeholder: "搜索文章",
                  clearable: ""
                }, null, 8, ["onKeyup", "modelValue"])
              ]),
              _createVNode(_component_el_button, {
                icon: _unref(Search),
                circle: "",
                style: {"margin-top":"12px","margin-left":"-60px"},
                onClick: search
              }, null, 8, ["icon"])
            ]),
            _: 1
          }, 8, ["default-active"])
        ]),
        _: 1
      }),
      _createVNode(_component_el_main, { class: "suep-main" }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_router_view)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_el_footer, { style: {"height":"1px"} }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})